/* eslint-disable no-unused-vars */
export const loading = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({

  '.blocker-image': {
    display: 'inline-block',
    width: 26,
    height: '26px',
    position: 'absolute',
    top: 215,
    left: 207,
  },

  '.blocker-image:after': {
    content: '" "',
    display: 'block',
    width: 26,
    height: '26px',
    margin: '1px',
    borderRadius: '50%',
    border: '1px solid',
    borderRightColor: '#0078D4',
    borderLeftColor: '#CDE6F7',
    borderTopColor: '#CDE6F7',
    borderBottomColor: '#CDE6F7',
    animation: 'spinner 1.2s linear infinite',
  },

  '@keyframes spinner': {
    to: {
      transform: 'rotate(360deg)',
    },
  },
});

